import * as React from 'react';
import { USER_TYPING_DEBOUNCE_TIME } from '@helpcenter/constants';
import { isNewSummaryFieldA11yEnabled, isSummaryFieldDebounced } from 'feature-flags';
import { debounce, isEmpty } from 'lodash';

import type { KnowledgeArticle } from 'state/ui/search';
import { KbSuggestedArticles } from 'view/common/fields/kb-suggestions';
import { TextField } from 'view/common/fields/text-field';
import { withControlledFormComponentValue } from 'view/common/with-controlled-form-component-value';
import type { FieldFormProps } from 'view/common/fields/types';

export interface Props extends FieldFormProps<string> {
    kbArticles?: KnowledgeArticle[];
    defaultValue?: string;
    valueOverride?: string;
    portalId?: number;
}

const ControlledTextField = withControlledFormComponentValue((_field: string, value: string) => value)(TextField);

const SummaryDumbField: React.FunctionComponent<Props> = ({ kbArticles, ...props }) => {
    const isNewSummaryField = isNewSummaryFieldA11yEnabled();

    const debouncedOnChange = React.useMemo(() => {
        if (props.onChange) {
            return debounce(props.onChange, USER_TYPING_DEBOUNCE_TIME);
        }
        return props.onChange;
    }, [props.onChange]);

    return (
        <>
            <ControlledTextField
                id={props.id}
                label={props.label}
                required={props.required}
                defaultValue={props.defaultValue}
                valueOverride={props.valueOverride}
                description={props.description}
                onChange={isSummaryFieldDebounced() ? debouncedOnChange : props.onChange}
                onFieldBlurredByUser={props.onFieldBlurredByUser}
                key="summary-text-field"
                errorMessage={props.errorMessage}
                disabled={props.disabled}
                updatedTextField={isNewSummaryField}
            />
            {!!kbArticles && !isEmpty(kbArticles) && (
                <KbSuggestedArticles articles={kbArticles} portalId={props.portalId} />
            )}
        </>
    );
};

export default SummaryDumbField;
